export enum PropertyKeyCollectType {
  CanCollect = 1,
  CanCollectWithDate = 2,
  CannotCollect = 3,
  KeySafe = 4,
  Custom = 5
}

export enum JobsListTypes {
  None = 0,
  UnscheduledJobs = 1, //Unscheduled(previous application joblisttype : 4)
  InProgressJobs = 2, //In Progress(previous application joblisttype : 5)
  PendingReviewJobs = 3, //Invoice Review(previous application joblisttype : 7)
  CompletedJobs = 4, //Completed(previous application joblisttype : 8)
  QuotedJobs = 5, //Quotes Available(previous application joblisttype : 10)
  PendingApprovalJobs = 6, //Tenant posted(previous application joblisttype : 11)
  PendingOwnerApprovalJobs = 7, //Pending Owner Approval(previous application joblisttype : 12)
  OwnerApprovedJobs = 8, //Owner Approved(previous application joblisttype : 13)
  PostedJobs = 9, //Quotes Pending(previous application joblisttype : 14)
  OverdueJobs = 10, //Overdue(previous application joblisttype : 16)
  RecurringJobs = 11, //Recurring Job(previous application joblisttype : 18)
  ScheduledJobs = 12, //Scheduled(previous application joblisttype : 19)
  DraftedJobs = 13, //Draft Job(previous application joblisttype : 20)
  InactiveJobs = 14, //Inactive(previous application joblisttype : 21)
  RejectedJobs = 15, //Rejected Jobs(previous application joblisttype : 22)
  PendingScheduleApproval = 16, //Pending Schedule(previous application joblisttype : 26)
  QuotesPendingJobs = 17, //Quotes Pending(previous application joblisttype : 29)
  OwnerRejectedJobs = 18, //Owner Rejected Job(previous application joblisttype : 30)
  PostedJobForThirdParty = 19, //External Job(previous application joblisttype : 32)
  VariationAvailableJobs = 20, //Variation Job(previous application joblisttype : 37)
  PendingInvoiceJobs = 21, //Pending Invoice(previous application joblisttype : 39)
  TradePosted = 22, //tradeposted(previous application joblisttype : 63)
  InspectionDraftedJobs = 42 //Inspection drafted jobs(added joblisttype : 42 to both old and new project: AN-59090)
}

export const JobTypesDisplayList = new Map<number, string>([
  [JobsListTypes.None, ''],
  [JobsListTypes.PendingApprovalJobs, 'Tenant Posted'],
  [JobsListTypes.PendingOwnerApprovalJobs, 'Pending Owner Approval'],
  [JobsListTypes.DraftedJobs, 'Draft Jobs'],
  [JobsListTypes.OwnerApprovedJobs, 'Owner Approved'],
  [JobsListTypes.QuotedJobs, 'Quotes Available'],
  [JobsListTypes.PostedJobs, 'Quotes Pending'],
  [JobsListTypes.UnscheduledJobs, 'Unscheduled'],
  [JobsListTypes.PendingScheduleApproval, 'Pending Schedule'],
  [JobsListTypes.ScheduledJobs, 'Scheduled'],
  [JobsListTypes.InProgressJobs, 'In Progress'],
  [JobsListTypes.OverdueJobs, 'Overdue'],
  [JobsListTypes.PostedJobForThirdParty, 'External'],
  [JobsListTypes.RecurringJobs, 'Recurring'],
  [JobsListTypes.VariationAvailableJobs, 'Variation Jobs'],
  [JobsListTypes.PendingInvoiceJobs, 'Pending Invoice'],
  [JobsListTypes.PendingReviewJobs, 'Job Approval Pending'],
  [JobsListTypes.CompletedJobs, 'Completed'],
  [JobsListTypes.InactiveJobs, 'Inactive'],
  [JobsListTypes.OwnerRejectedJobs, 'Owner Rejected jobs'],
  [JobsListTypes.RejectedJobs, 'Rejected jobs'],
  [JobsListTypes.TradePosted, 'Trade Posted'],
  [JobsListTypes.InspectionDraftedJobs, 'Inspection Drafted'],
]);

export enum LabelColors {
  Default = 'black',
  Success = 'success',
}

export enum AccountingType {
  None = 0,
  Xero = 1,
  MYOBAccountRight = 2,
  MYOBEssentials = 3,
  QB = 4,
}

export enum PropertyType {
  Residential = 0,
  Commercial = 1,
  Unknown = 2,
  Strata = 3,
}

export enum RecurranceType {
  None = 0,
  Daily = 1,
  Weekly = 7,
  Fortnightly = 14,
  Monthly = 30,
  Quarterly = 90,
  SemiAnnually = 180,
  Annually = 365,
  Seasonal = 400,
  Custom = 999,
}

export enum RecurranceCustomType {
  None = 0,
  OneWeek = 1,
  TwoWeeks = 2,
  ThreeWeeks = 3,
  FourWeeks = 4,
  FiveWeeks = 5,
  SixWeeks = 6,
  SevenWeeks = 7,
  EightWeeks = 8,
  NineWeeks = 9,
  TenWeeks = 10,
}

export enum WorkflowStates {
  JobDrafted = 1,
  JobPosted = 2,
  JobQuotesAvailable = 3,
  JobQuoteAccepted = 4,
  JobAwaitingForApproval = 5,
  JobAwaitingOwnerApproval = 6,
  JobCompleted = 7,
  JobArchived = 8,
  JobApprovedByOwner = 9,
  JobApprovedByPM = 10,
  JobRejectedByOwner = 11,
  JobCompletedBySubcontractor = 12,
  BidCreated = 101,
  BidAccepted = 102,
  BidRejected = 103,
  JobCancelled = 104,
  BidJobCancelled = 105,
  JobRejected = 106,
  JobPendingReview = 107,
  BidDeclined = 110,
  JobPendingInvoice = 111,
  VariationCreated = 201,
  VariationApproved = 202,
  VariationRejected = 203,
  JobAwardPendingApproval = 204,
  JobPostedForThirdParty = 205,
  Inactive = 206,
  VariationPendingReview = 207,
  VariationRejectedByAdmin = 208,
  VariationInvoiceAdded = 209,
  VariationCancelled = 210,
  JobCeased = 109,
  bidDeclined = 110,
  JobPendingCustomerInvoice = 211,
}

export enum UrgencyType {
  None = 0,
  Emergency = -1,
  Urgent = 1,
  Normal = 2,
}

export enum InvoiceStatus {
  Draft = 1,
  Submitted = 2,
  Deleted = 3,
  Authorised = 4,
  Paid = 5,
  Voided = 6,
}

export enum JobAction {
  WorkOrder = 1,
  TaskDetails = 2,
  Approve = 3,
  Reject = 4,
  SendforOwnerApproval = 5,
  ChangeJobPayer = 6,
  JobEdit = 7,
  ReAwardJob = 8,
  DeactivateJob = 9,
  InviteTrades = 10,
  ResendJob = 11,
  RemindTradestoQuote = 12,
  QuoteRequest = 13,
  ApproveInvoice = 14,
  RemindTradeToComplete = 15,
  ScheduleTask = 16,
  AddJobVariation = 17,
  SwitchJob = 18,
  ViewInvoice = 19,
  OwnerOverride = 20,
  AcceptRejection = 21,
  RemindOwners = 22,
  ResendOwnerApproval = 23,
  UpdateSchedule = 24,
  ApproveScheduledTask = 25,
  CompleteJob = 26,
  RemoveRecurringJob = 27,
  JobSnooze = 28,
  Accept = 29,
  AcceptVariation = 30,
  RejectVariation = 31,
  OwnerOverrideVariation = 32,
  Clone = 33,
  CancelInvoice = 34,
  EditRecurringJob = 35,
  InvoicePending = 36,
  CreditorInvoice = 37,
  AcceptJobAsInProgress = 38,
  AddInvoice = 39,
  WOConvertToQR = 40,
  QRConvertToWO = 41,
  AcceptWithAI = 42
}

export enum ServiceStatus {
  None = 0,
  WarrantyToPaid = 1,
  PaidToWarranty = 2,
}
export enum OwnerApprovalStatus {
  Pending = 6,
  Approved = 9,
  Rejected = 11,
}

export enum ChannelType {
  Unknown = 0,
  Web = 1,
  iOS = 2,
  Android = 3,
  Email = 4,
  Sms = 5,
  Ivr = 6,
  Messenger = 7,
  Whatsapp = 8,
  GoogleHome = 9,
  API = 10,
  WeChat = 11,
  AgencyChatBot = 12,
  InspectionManager = 13
}

export enum QuoteTypes {
  None = 0,
  QuoteAmount = 1,
  QuoteEstimate = 2,
  FixedFee = 3,
  HourlyRate = 4,
  QuoteXero = 5,
}

export enum RecurringJobsState {
  UnCompleteJobsOnly = 0,
  CompleteJobsOnly = 1,
  AllJobs = 2,
}

export enum InvoiceCancellationStatus
{
    Requested = 1,
    Queued = 2,
    Failed = 3,
    Success = 4
}
